Vendd.Scripts.load(function () {
    'use strict';

    (function() { // Init dataLayer 
        window.dataLayer = window.dataLayer || [];
        var dl = window.dataLayer;
        var originalPush = dl.push;
        dl.push = function (args) {
            // Prevent the push of vendd_consents_ready
            if (args.event && args.event == "vendd_consents_ready") return;

            originalPush.call(window.dataLayer, args);
            onDataLayerPush(args); // Hook to dataLayer.push method
        }
        function onDataLayerPush(args) {
            if (typeof args.event == "undefined") return;

            if (args.event === 'OneTrustLoaded') {
                if (args.OnetrustActiveGroups.indexOf('C0002') > -1) {
                    skodaVariables.consents.analytics = true;
                    initScripts('analytics');
                }
                if (args.OnetrustActiveGroups.indexOf('C0004') > -1) {
                    skodaVariables.consents.marketing = true;
                    initScripts('marketing');
                }
            }
        }
    })();
});